import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  account_number: "",
  amount: "",
  bank_name: "",
  country: "",
  paypal_email: "",
  routing_number: "",
  swift_code: " ",
  default_us:"USA" //USA accont readonly country name 
};

export const withdrawSlice = createSlice({
  name: "market/withdraw",
  initialState,
  reducers: {
    setAccountNo: (state, action) => {
      state.account_number = action.payload;
    },
    setAmount: (state, action) => {
      state.amount = parseInt(action.payload);
    },
    setBankName: (state, action) => {
      state.bank_name = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setRoutingNo: (state, action) => {
      state.routing_number = action.payload;
    },

    setPaypalEmail: (state, action) => {
      state.paypal_email = action.payload;
    },
    setSwiftCode: (state, action) => {
      state.swift_code = action.payload;
    },
    setToDefault: (state, action) => {
      state = {
        account_number: "",
        amount: "",
        bank_name: "",
        country: "",
        paypal_email: "",
        routing_number: "",
        swift_code: " ",
        default_us: "USA",
      };
    }
  },
});

export const {
  setAccountNo,
  setAmount,
  setBankName,
  setCountry,
  setPaypalEmail,
  setRoutingNo,
  setSwiftCode,
  setToDefault,
} = withdrawSlice.actions;

export default withdrawSlice.reducer;
